<h1 mat-dialog-title>Controles</h1>

<div mat-dialog-content>
    <ul *ngIf="data && data.length > 0; else noData">
        <li *ngFor="let item of data">
            <div>
                <strong>Fecha:</strong> {{ item.Date | date:'dd/MM/yyyy' }}
            </div>
            <div>
                <strong>Estado:</strong> {{ item.Status }}
            </div>
            <div>
                <strong>Observación:</strong> {{ item.Observation }}
            </div>
            <hr />
        </li>
    </ul>

    <ng-template #noData>
        <span>No hay controles cargados</span>
    </ng-template>
</div>

<div class="clearfix">
    <div class="pull-right">
        <button mat-button type="button" cdkFocusInitial (click)="onNoClick()">
      Salir
    </button>
    </div>
</div>